import { useEffect, useState, useContext, useRef } from "react";
import axios from 'axios';

import { Folder, FilePlus, Paperplane } from "../../files/icons/index.js";

import { PhysicianAvatar } from "../components/component.js";

import { AppContext } from '../../context.js';

import { DatetimeToDate, DateToFormat } from "../../utils/datetime.js";

import { FilesPreview, isFileForPreview } from "../components/filePreview.js";

import Editor from "./editor.js";

function Chat(props) {
  const { referralID, patientID, projectID, sectionID, taskID, appointmentID, assessmentID, scope, autoscroll, createMessageCallback, placeholder, inline = true, methods } = props;

  const context = useContext(AppContext);

  const [loading, setLoading] = useState(true);

  const [messages, setMessages] = useState([]);

  const fileUploadRef = useRef(null);

  const [closeReactionDrop, setCloseReactionDrop] = useState(0);

  const [messageText, setMessageText] = useState("");

  const [uploadFiles, setUploadFiles] = useState([]);

  useEffect(() => {
    let u = context.addSpiner();
    axios.post('/api/admin/chats', {
      referralID: referralID ? referralID : null,
      patientID: patientID ? patientID : null,
      projectID: projectID ? projectID : null,
      sectionID: sectionID ? sectionID : null,
      taskID: taskID ? taskID : null,
      appointmentID: appointmentID ? appointmentID : null,
      assessmentID: assessmentID ? assessmentID : null,
      scope: scope ? scope : null,
    }).then((response) => {
      setMessages(response.data.messages);
      setLoading(false);
    }).catch((e) => {
      context.addError(e);
      context.removeSpiner(u);
    }).finally(() => {
      context.removeSpiner(u);
    });
  }, [referralID, patientID, projectID, sectionID, taskID, appointmentID, assessmentID, scope]);


  // New message
  function updateMessageText(text, id) {
    if (text === "" || text === "<p><br></p>") {
      text = null;
    }

    setMessageText(text);
  }

  function triggerFileInput() {
    fileUploadRef.current.click();
  }

  function changeFileInput(e) {
    var uploaded = [];
    for (var i = 0; i < e.target.files.length; i++) {
      uploaded.push(e.target.files[i]);
    }
    setUploadFiles(uploadFiles.concat(uploaded));
    // Reset the file input so subsequent uploads trigger onChange
    e.target.value = '';
  }

  function createMessage() {
    if (messageText === "" && uploadFiles.length === 0) {
      console.log("No message");
      return;
    }

    var data = new FormData();

    data.append('referralID', referralID ? referralID : null);
    data.append('patientID', patientID ? patientID : null);
    data.append('projectID', projectID ? projectID : null);
    data.append('sectionID', sectionID ? sectionID : null);
    data.append('taskID', taskID ? taskID : null);
    data.append('appointmentID', appointmentID ? appointmentID : null);
    data.append('assessmentID', assessmentID ? assessmentID : null);
    data.append('scope', scope ? scope : null);

    data.append('content', messageText);

    data.append('fileLength', uploadFiles.length);

    for (var i = 0; i < uploadFiles.length; i++) {
      data.append('file'+i, uploadFiles[i]);
    }
    
    let u = context.addSpiner();
    axios.post('/api/admin/chats/message', data).then((response) => {
      setMessages(messages.concat(response.data));
      setMessageText("");
      setUploadFiles([]);
      createMessageCallback();
    }).catch((e) => {
      context.addError(e);
      context.removeSpiner(u);
    }).finally(() => {
      context.removeSpiner(u);
    });
  }

  if (loading) {
    return (
      <></>
    );
  }

  let height = 60;
  if (uploadFiles.length > 0) {
    height += uploadFiles.length * 60;
  }

  return (
    <div style={{height: '100%'}}>
      <input ref={fileUploadRef} type="file" className="d-none" onChange={changeFileInput} accept=".jpg,.jpeg,.png,.tiff,.pdf" multiple={true} />

      <div className="scrollable" style={{height: "calc(100% - "+height+"px)", overflowY: 'auto'}}>
      
        {/* {messages.length === 0 && (
          <span className="typo-normal-150">No messages</span>
        )} */}

        {messages.map((message, i) => {
          return (
            <div key={i} className={messages.length !== i + 1 ? "mb-3" : ""}>
              <div className="d-flex justify-content-start align-items-center">
                <div style={{width: 26}}>
                  <PhysicianAvatar id={message.createdBy} alt="logo" style={{height: 20, width: 20}} />
                </div>
                <div className="typo-strong-150">{message.createdByName}</div>
                <div className="typo-normal-150 ps-1">at {DateToFormat(DatetimeToDate(message.createdAt), context.dateFormat)} {DateToFormat(DatetimeToDate(message.createdAt), context.timeFormat === "us" ? "AMPM" : "HH:mm")}</div>
              </div>

              {message.content && message.content !== "" && message.content !== "<p><br></p>" && (
                <div style={{paddingLeft: 26}}>
                  <div className={"item " + (message.createdBy === context.id ? "blue" : "grey")}>
                    <Editor 
                      value={message.content}
                      readOnly={true}
                      className="text-editor borderless w-100"
                    />
                  </div>
                </div>
              )}

              {message.files && message.files.length > 0 && (
                <div className="mt-2" style={{paddingLeft: 26}}>
                  <FilesPreview ids={message.files} />
                </div>
              )}

            </div>
          );
        })}
      </div>

      {messages.length > 0 && (
        <hr className="mt-2 mb-2" style={{borderTop: '#ddd'}} />
      )}

      {inline ? (
        <>
          <div className="d-flex justify-content-start align-items-top">
            <div className="pe-1">
              <div className="item" onClick={() => triggerFileInput()}>
                <FilePlus height={16} width={16} color={'grey'} />
              </div>
            </div>
            
            <Editor 
              placeholder={placeholder ? placeholder : "Message..."}
              value={messageText}
              onChangeID={null}
              onChange={updateMessageText}
              toolbar="limited"
              className="text-editor borderless w-100 mt-1"
            />
            
            <div className="ps-1">
              <div className="item" onClick={() => createMessage()}>
                <Paperplane height={16} width={16} color={'grey'} />
                <span className="typo-normal-150">Send</span>
              </div>
            </div>
          </div>

          {uploadFiles.length > 0 && (
            <div style={{paddingLeft: 26}}>
              {uploadFiles.map((file) => {
                return UploadFilePreview(file);
              })}
            </div>
          )}
        </>
      ) : (
        <>
          <div className="d-flex justify-content-start align-items-top ps-1 mb-2">
            <Editor 
              placeholder={placeholder ? placeholder : "Message..."}
              value={messageText}
              onChangeID={null}
              onChange={updateMessageText}
              toolbar="limited"
              className="text-editor borderless w-100 mt-1"
            />
          </div>

          {uploadFiles.length > 0 && (
            <div >
              {uploadFiles.map((file) => {
                return UploadFilePreview(file);
              })}
            </div>
          )}

          <div className="d-flex justify-content-between align-items-bottom mt-2">
            <div className="item grey" onClick={() => triggerFileInput()}>
              <FilePlus height={16} width={16} color={'grey'} />
              <span className="typo-normal-150">Attach files</span>
            </div>
            <div className="item grey" onClick={() => createMessage()}>
              <Paperplane height={16} width={16} color={'grey'} />
              <span className="typo-normal-150">Send</span>
            </div>
          </div>
        </>
      )}

      {/* {uploadFiles.length > 0 && (
        <div style={{paddingLeft: 26}}>
          {uploadFiles.map((file) => {
            return UploadFilePreview(file);
          })}
        </div>
      )} */}
    </div>
  )
}

function UploadFilePreview(file) {
  const fileURL = URL.createObjectURL(file);

  return (
    <div className="d-flex justify-content-start align-items-center mt-2">
      <div className="text-center"></div>
      <div className="d-flex justify-content-start align-items-center item w-100">
        <div className="d-flex justify-content-center align-items-center" style={{height: '40px', width: '60px', border: "1px solid #ddd"}}>
          {isFileForPreview(file.name) ? (
            <img src={fileURL} style={{maxHeight: '40px', maxWidth: '100%'}} />
          ) : (
            <Folder height={16} width={16} color={'grey'} />
          )}
        </div>
        <span className="typo-normal-125 ms-1">{file.name}</span>
      </div>
    </div>
  );
}

export default Chat;